import olga from './olga'

olga.standalone = true

global.olga = olga

export default olga
